document.addEventListener("DOMContentLoaded", function () {

  const FREE_SHIPPING_WEIGHT = 3500; // 3.5 kg
  let lastProgress = parseFloat(sessionStorage.getItem("lastProgress")) || 0;
  let lastMessage = sessionStorage.getItem("lastMessage") || "";

  function debounce(fn, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  }

  function updateProgressBar(cart) {
    const container = document.querySelector("#free-shipping-progress");
    if (!container)
      return console.warn("[ProgressBar] Progress bar container not found");

    const fill = container.querySelector("#progress-fill");
    const message = container.querySelector("#progress-message");
    if (!fill || !message)
      return console.warn("[ProgressBar] Missing fill or message element");

    const totalWeight = cart.items.reduce(
      (sum, item) => sum + item.grams * item.quantity,
      0
    );
    const progress =
      cart.item_count === 0
        ? 0
        : Math.min((totalWeight / FREE_SHIPPING_WEIGHT) * 100, 100);

    if (cart.item_count === 0) {
      fill.style.transition = "none";
      fill.style.width = "0%";
      container.style.opacity = "0";
      container.style.display = "none";

      setTimeout(() => {
        fill.style.transition = "width 0.4s ease";
      }, 100);
    } else {
      container.style.display = "block";
      container.style.opacity = "1";
      fill.style.width = progress + "%";
    }


    const messageText =
      totalWeight >= FREE_SHIPPING_WEIGHT
        ? "You’ve qualified for free shipping!"
        : `Add ${((FREE_SHIPPING_WEIGHT - totalWeight) / 1000).toFixed(
            2
          )} kg more for free shipping.`;

    if (message.textContent !== messageText) {
      message.textContent = messageText;
    }

    lastProgress = progress;
    lastMessage = messageText;
    sessionStorage.setItem("lastProgress", progress);
    sessionStorage.setItem("lastMessage", messageText);
  }

  function refreshProgress() {
    const fill = document.querySelector("#progress-fill");
    const message = document.querySelector("#progress-message");
    if (fill) fill.style.width = lastProgress + "%";
    if (message && lastMessage) message.textContent = lastMessage;

    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        updateProgressBar(cart);
      })
      .catch((err) =>
        console.error("[ProgressBar] Error fetching /cart.js:", err)
      );
  }

  const debouncedRefresh = debounce(refreshProgress, 200);

  // Initial load
  refreshProgress();

  // Listen for cart:updated (if theme dispatches it)
  document.addEventListener("cart:updated", (event) => {
    if (event.detail && event.detail.cart) {
      updateProgressBar(event.detail.cart);
    } else {
      debouncedRefresh();
    }
  });

  // Watch for cart drawer re-render or updates (universal fallback)
  const cartDrawer = document.querySelector("cart-drawer-component");
  if (cartDrawer) {
    const observer = new MutationObserver(() => {

      // Immediately reapply last known progress before async fetch
      const fill = document.querySelector("#progress-fill");
      if (fill && !fill.style.width) {
        fill.style.width = lastProgress + "%";
      }

      debouncedRefresh();
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // Shopify theme section reloads
  document.addEventListener("shopify:section:load", debouncedRefresh);

  // Fallback: intercept Shopify AJAX add-to-cart calls
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    const url = typeof args[0] === "string" ? args[0] : args[0].url;
    if (url && url.includes("/cart/add")) {
      debouncedRefresh();
    }
    return response;
  };
});
